// Labels for a milestone the home is working toward (present progressive).
// Shown in the "What's next?" section of the homeowner timeline.
export const NEXT_MILESTONE_MAP = {
  InspectionScheduled: 'Scheduling Your Inspection',
  InspectionCompleted: 'Completing Your Inspection',
  PostInspectionProposalSent: 'Sending Your Report',
  PostInspectionProposalApproved: 'Approving Your Report',
  ShowReady: 'Readying Your Home To Be Shown',
  FullListingPublished: 'Publishing Your Listing',
  LeaseExecuted: 'Finding Your Home Love',
  MoveInReady: 'Readying Your Home To Be Moved Into',
  ResidentMovedIn: 'Moving Your Residents In',
  ManagingAdoptedResidents: 'Starting To Manage Your Residents',
  ListingRepublished: 'Publishing Your Listing',
};

// Labels for a milestone that already happened (past tense).
// Shown on completed events in the homeowner timeline log.
export const COMPLETED_MILESTONE_MAP = {
  InspectionScheduled: 'Scheduled Your Inspection',
  InspectionCompleted: 'Completed Your Inspection',
  PostInspectionProposalSent: 'Sent Your Report',
  PostInspectionProposalApproved: 'Approved Your Report',
  ShowReady: 'Your Home Is Ready To Be Shown',
  FullListingPublished: 'Published Your Listing',
  LeaseExecuted: 'Found Your Home Love',
  MoveInReady: 'Your Home Is Ready To Be Moved Into',
  ResidentMovedIn: 'Moved Your Residents In',
  ManagingAdoptedResidents: 'Started To Manage Your Residents',
  ListingRepublished: 'Published Your Listing',
  MoveInPrepped: 'Move In Prepped',
};

export const NEXT_REQUIRED_EVENTS_BLACK_LIST = {
  ResidentGaveNotice: 'ResidentGaveNotice',
  PricingAdjusted: 'PricingAdjusted',
  SignageCompleted: 'SignageCompleted',
};

export const TAB_ITEMS = [
  {
    key: 'timeline',
    text: 'My Home Timeline',
  },
  {
    key: 'residents',
    text: 'My Wonderful Residents',
  },
];
